export const queryKeys = {
  reports: 'reports',
  invoices: 'invoices',
  consumption: 'consumption',
  forecastedCost: 'forecastedCost',
  forecastedUsage: 'forecastedUsage',
  consumptionYearly: 'consumptionYearly',
  consumptionSelectedMonths: 'consumptionSelectedMonths',
  consumptionMonthly: 'consumptionMonthly',
  consumptionReportTableData: 'consumptionReportTableData',
  totalConsumption: 'totalConsumption',
  averageConsumption: 'averageConsumption',
  consumptionTrendKPI: 'consumptionTrendKPI',
  totalConsumptionKPI: 'totalConsumptionKPI',
  openInvoicesKPI: 'openInvoicesKPI',
  userInfo: 'userInfo',
  deliveryPoints: 'deliveryPoints',
  deliveryPoint: 'deliveryPoint',
  gooCertificatesMetadata: 'gooCertificatesMetadata',
  marketingInfo: 'marketingInfo',
  enclosures: 'enclosures',
  survey: 'survey',
  admin: 'admin',
  salesTiles: 'salesTiles',
};
